import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, SignalMedium } from 'lucide-react';

// online / weak / offline chip. `lastUpdate` (ms) marks weak if stale.
export const useOnline = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  return online;
};

export const ConnectionStatus = ({ weak = false, testid = 'connection-status' }) => {
  const online = useOnline();
  let state = 'online';
  if (!online) state = 'offline';
  else if (weak) state = 'weak';

  const cfg = {
    online: { label: 'Online', Icon: Wifi, color: 'var(--success)' },
    weak: { label: 'Weak signal', Icon: SignalMedium, color: 'var(--warning)' },
    offline: { label: 'Offline', Icon: WifiOff, color: 'var(--danger)' },
  }[state];
  const { Icon } = cfg;

  return (
    <span
      data-testid={testid}
      data-state={state}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold border"
      style={{ color: cfg.color, borderColor: 'var(--border)', background: 'var(--surface)' }}
    >
      <Icon size={14} /> {cfg.label}
    </span>
  );
};
